export class BlockNotasPMModel{
    idBlockNotas:number;
    idJardinPeriodo:number;
    contenido:string;

    constructor(){
        this.idBlockNotas = 0;
        this.idJardinPeriodo = 0;
        this.contenido = "";
    }
}

export class ResponseBlockNotasPMModel{
    payload:BlockNotasPMModel[];

    constructor(){
        this.payload = new Array<BlockNotasPMModel>();
    }
}
 